import React, { useContext } from "react";
import { Logout, ToastMessage } from "../../../../utils/Helper";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import CompanyCreateFormPopup from "./PostsCreateFormPopup";
import Breadcrumb from "../../../../reuseable/Breadcrumb/Breadcrumb";
import {
  COMPANY,
  COMPANY_LIST,
  SLACE,
} from "../../../../reuseable/Breadcrumb/BreadcrumbConstant";
import CompanyDataTableContainer from "./PostsDataTableContainer";
import PostsContext from "../../../../context/PostsContext/PostsContext";
import { get_Posts } from "../../../../Apis/postsApi/postsApi";

const Posts = () => {
  const {
    //pagination state variables
    pageSize,
    page,
    setRecord,
    sortOrder,
    sortBy,
    filter,

    //company edit condition state and data object state
    setDialogs,
    setErrors,
    dialog,
    setIsEdit,
    setFormData,
    setFilterDrop,
  } = useContext(PostsContext);

  const history = useNavigate();

  /**
   * get Posts List
   */

  let paramsObj = {
    pageNumber: page,
    recordsPerPage: pageSize,
    sortOrder,
    sortBy,
  };
  if (filter.length) {
    paramsObj["search"] = { title: filter };
  }

  let { data, refetch, isLoading, error } = useQuery(
    ["get_Posts", paramsObj],
    () => get_Posts(paramsObj),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      refetchOnReconnect: false,
      retry: 3,
      onSuccess: (response) => {
        if (response.status === 200) {
          setRecord(response.pager.totalRecords);
        }
      },
    }
  );
  if (error) {
    const { status, message } = error?.response?.data || error;
    ToastMessage(status, message);
    Logout(history, status);
  }

  const emptyData = () => {
    setFormData({
      defaultImage: null,
      description: null,
      image: null,
      imageType: null,
      isActive: null,
      isPremium: null,
      isSameDay: null,
      languageDetail: null,
      languageId: null,
      postDate: null,
      postSendDate: null,
      postId: null,
      religionDetail: null,
      religionId: null,
      templateImage: null,
      thumbImage: null,
      title: null,
      type: null,
      xDescription: null,
    });
    setFilterDrop((prev) => {
      return { ...prev, storeFilter: "" };
    });
  };

  /**
   * Open Popup and Close Popup Posts
   */
  const handleOpenandClosePopup = (condition) => {
    setIsEdit(true);
    if (condition) {
      setDialogs(condition);
      emptyData();
      setErrors({});
    } else {
      setDialogs(condition);
      emptyData();
      setErrors({});
    }
  };
  return (
    <>
      <Breadcrumb name={COMPANY} slace={SLACE} name1={COMPANY_LIST} />
      <CompanyDataTableContainer
        isLoading={isLoading}
        data={data}
        handleOpenandClosePopup={handleOpenandClosePopup}
        refetch={refetch}
      />
      {dialog && (
        <CompanyCreateFormPopup
          handleOpenandClosePopup={handleOpenandClosePopup}
          refetch={refetch}
          emptyData={emptyData}
        />
      )}
    </>
  );
};

export default Posts;
